import React, { useState, useEffect, useMemo } from "react";
import { Button, Modal } from "react-bootstrap";
import DataTableSearch from "../Common/HelpCommon/DataTableSearch";
import DataTablePagination from "../Common/HelpCommon/DataTablePagination";
import axios from "axios";
import "../App.css";

const API_URL = process.env.REACT_APP_API;
var lActiveInputFeild = ''

const CompanyMasterHelp = ({ onAcCodeClick, name, CompanyName, CompanyCode, disabledFeild, tabIndexHelp }) => {
    const [showModal, setShowModal] = useState(false);
    const [popupContent, setPopupContent] = useState([]);
    const [enteredAcCode, setEnteredAcCode] = useState(CompanyCode || "");
    const [enteredAcName, setEnteredAcName] = useState(CompanyName || "");
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRowIndex, setSelectedRowIndex] = useState(-1);

    const itemsPerPage = 10;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_URL}/get_company_data_All`);
                setPopupContent(response.data.Company_Data || []);
                if (CompanyCode) {
                    const foundItem = response.data.Company_Data.find(item => item.Company_Code.toString() === CompanyCode.toString());
                    if (foundItem) {
                        setEnteredAcCode(foundItem.Company_Code);
                        setEnteredAcName(foundItem.Company_Name_E);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [CompanyCode]);


    useEffect(() => {
        setEnteredAcCode(CompanyCode || "");
        setEnteredAcName(CompanyName || "");
    }, [CompanyCode, CompanyName]);


    const filteredData = useMemo(() => {
        return popupContent.filter((item) =>
            item.Company_Name_E?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(item.Company_Code)?.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [popupContent, searchTerm]);


    const itemsToDisplay = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        return filteredData.slice(startIndex, startIndex + itemsPerPage);
    }, [filteredData, currentPage, itemsPerPage]);


    const handleSearch = (searchValue) => {
        setSearchTerm(searchValue);
        setCurrentPage(1);
    };

    const handleMillCodeButtonClick = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleAcCodeChange = (event) => {
        const value = event.target.value;
        setEnteredAcCode(value);
        setEnteredAcName("");

          if (value === "") {
            setEnteredAcCode("");
            setEnteredAcName("");
            onAcCodeClick?.("", "");
        }

        const matchingItem = popupContent.find((item) => item.Company_Code.toString() === value);
        if (matchingItem) {
            setEnteredAcName(matchingItem.Company_Name_E);
            onAcCodeClick?.(matchingItem.Company_Code, matchingItem.Company_Name_E);
        }
    };

    const handleRecordDoubleClick = (item) => {
        setEnteredAcCode(item.Company_Code);
        setEnteredAcName(item.Company_Name_E);
        setShowModal(false);
        onAcCodeClick?.(item.Company_Code, item.Company_Name_E);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "F1") {
                if (event.target.id === name) {
                    lActiveInputFeild = name;
                    event.preventDefault();
                    setShowModal(true);
                }
            } else if (event.key === "Tab" && showModal) {
                event.preventDefault();
                if (selectedRowIndex >= itemsToDisplay.length - 1) {
                    setSelectedRowIndex(0);
                } else {
                    setSelectedRowIndex((prev) => prev + 1);
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [showModal, selectedRowIndex, itemsToDisplay]);

    useEffect(() => {
        const handleKeyNavigation = (event) => {
            if (showModal) {
                if (event.key === "ArrowUp") {
                    event.preventDefault();
                    setSelectedRowIndex((prev) => Math.max(prev - 1, 0));
                } else if (event.key === "ArrowDown") {
                    event.preventDefault();
                    setSelectedRowIndex((prev) => Math.min(prev + 1, itemsToDisplay.length - 1));
                } else if (event.key === "Enter") {
                    event.preventDefault();
                    if (selectedRowIndex >= 0) {
                        handleRecordDoubleClick(itemsToDisplay[selectedRowIndex]);
                    }
                }
            }
        };

        window.addEventListener("keydown", handleKeyNavigation);

        return () => {
            window.removeEventListener("keydown", handleKeyNavigation);
        };
    }, [showModal, selectedRowIndex, itemsToDisplay, handleRecordDoubleClick]);

    return (
        <div className="d-flex flex-row">
            <div className="d-flex">
    <select
        className="form-select ms-2"
        value={enteredAcCode}
        onChange={(e) => {
            const selectedCode = e.target.value;

            setEnteredAcCode(selectedCode);

            const selectedCompany = popupContent.find(
                item => item.Company_Code.toString() === selectedCode
            );

            if (selectedCompany) {
                setEnteredAcName(selectedCompany.Company_Name_E);

                onAcCodeClick?.(
                    selectedCompany.Company_Code,
                    selectedCompany.Company_Name_E
                );
            } else {
                setEnteredAcName("");
            }
        }}
        style={{ width: "350px", height: "35px" }}
        disabled={disabledFeild}
        tabIndex={tabIndexHelp}
    >
        <option value="">Select Company</option>

        {popupContent.map((item) => (
            <option
                key={item.Company_Code}
                value={item.Company_Code}
            >
                {item.Company_Code} - {item.Company_Name_E}
                
            </option>
        ))}
    </select>
</div>
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName="custom-small"
               style={{ zIndex: 9999 }}
            >
                <Modal.Header style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Modal.Title>Company Master </Modal.Title>
                    <Button
                        style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: 'blue', position: 'absolute', right: '10px' }}
                        onClick={handleCloseModal}
                    >
                        X
                    </Button>
                </Modal.Header>
                 <DataTableSearch data={popupContent} onSearch={handleSearch} />
                <Modal.Body>
                    <div className="table-responsive">
                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th>Company Code</th>
                                    <th>Company Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsToDisplay.map((item, index) => (
                                    <tr
                                        key={index}
                                        className={selectedRowIndex === index ? "selected-row" : ""}
                                        onDoubleClick={() => handleRecordDoubleClick(item)}
                                    >
                                        <td>{item.Company_Code}</td>
                                        <td>{item.Company_Name_E}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <DataTablePagination
                        totalItems={filteredData.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={handlePageChange}
                    />
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CompanyMasterHelp;
